// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UserManager extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  appointeeId!: number;
  createdBy?: string;
  createdDate!: Date;
  flags?: number;
  fromDate?: Date;
  managerId!: number;
  updatedBy?: string;
  updatedDate!: Date;
  userId!: number;
  appointee!: User;
  manager!: User;
  user!: User;
}

